function getDefaultColumns(chartType) {
    if (chartType === "CombinedCharts") {
        return sampleCombinedDataColumns;
    }
    if (chartType === "PieChart") {
        return samplePieDataColumns;
    }
    if (chartType === "HeatmapChart") {
        return sampleHeatmapChartColumns;
    }
    return sampleDataColumns;
}
function getDefaultItems(chartType) {
    if (chartType === "PieChart") {
        return samplePieDataItems;
    }
    if (chartType === "HeatmapChart") {
        return sampleHeatmapDataItems;
    }
    return sampleDataItems;
}
const sampleHeatmapChartColumns = [
    {
        field: "day",
        header: "Day",
        show: true,
        type: "VARCHAR",
        axis: "y"
    },
    {
        field: "employee",
        header: "Employee",
        show: true,
        type: "VARCHAR",
        axis: "x"
    },
    {
        field: "sales",
        header: "Sales",
        show: true,
        type: "BIGINT",
        axis: "value"
    }
];
const sampleCombinedDataColumns = [
    {
        field: "date",
        header: "Date",
        show: true,
        type: "date",
        chartType: ""
    },
    {
        field: "freeCashFlow",
        header: "Free Cash Flow",
        show: true,
        type: "BIGINT",
        chartType: "column"
    },
    {
        field: "netProfit",
        header: "Net Profit",
        show: true,
        type: "BIGINT",
        chartType: "spline",
        yAxis: 0
    },
    {
        field: "revenue",
        header: "Revenue",
        show: true,
        type: "BIGINT",
        chartType: "spline",
        yAxis: 1
    }
];
const sampleDataColumns = [
    {
        field: "date",
        header: "Date",
        show: true,
        type: "DATETIME"
    },
    {
        field: "netProfit",
        header: "Net Profit",
        show: true,
        type: "BIGINT"
    },
    {
        field: "revenue",
        header: "Revenue",
        show: true,
        type: "BIGINT"
    },
    {
        field: "freeCashFlow",
        header: "Free Cash Flow",
        show: true,
        type: "BIGINT"
    }
];
const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
const salespeople = ["Alexander", "Marie", "Maximillian", "Sophia", "Lukas"];
const sales = [
    10, 19, 8, 24, 67, 92, 58, 78, 117, 48, 35, 15, 123, 64, 52, 72, 132, 114, 19,
    16, 38, 5, 8, 117, 115
];
const data = days
    .map((day, i) => {
    return salespeople.map((person, j) => {
        const numOfDays = days.length;
        return {
            day,
            employee: person,
            sales: sales[i * numOfDays + j]
        };
    });
})
    .flat();
const sampleHeatmapDataItems = data;
const sampleDataItems = [
    {
        date: "2021-04-08",
        netProfit: 44,
        revenue: 76,
        freeCashFlow: 35
    },
    {
        date: "2021-04-09",
        netProfit: 55,
        revenue: 85,
        freeCashFlow: 41
    },
    {
        date: "2021-04-10",
        netProfit: 57,
        revenue: 101,
        freeCashFlow: 36
    },
    {
        date: "2021-04-11",
        netProfit: 56,
        revenue: 98,
        freeCashFlow: 26
    },
    {
        date: "2021-04-12",
        netProfit: 61,
        revenue: 87,
        freeCashFlow: 45
    },
    {
        date: "2021-04-13",
        netProfit: 58,
        revenue: 105,
        freeCashFlow: 48
    },
    {
        date: "2021-04-14",
        netProfit: 63,
        revenue: 91,
        freeCashFlow: 52
    },
    {
        date: "2021-04-15",
        netProfit: 60,
        revenue: 114,
        freeCashFlow: 53
    },
    {
        date: "2021-04-16",
        netProfit: 66,
        revenue: 94,
        freeCashFlow: 41
    }
];
const samplePieDataColumns = [
    { field: "title", header: "Title", show: true, type: "VARCHAR" },
    { field: "avg", header: "Average", show: true, type: "BIGINT" }
];
const samplePieDataItems = [
    { title: "Net Profit", avg: 44 },
    { title: "Revenue", avg: 85 },
    { title: "Free Cash Flow", avg: 36 }
];

export { getDefaultColumns, getDefaultItems };
//# sourceMappingURL=defaultData.js.map
